import { Button, ChakraProvider, useToast } from '@chakra-ui/react';
import { FaDownload } from 'react-icons/fa6';
import { useGetAgreementPromocodesFromBatchMutation } from '@partiu/api/dashboard/hooks.ts';
import { downloadCSV } from '@partiu/ui/utils.ts';
import { DataGridBooleanFormatter } from '../../formatters.ts';

export function DownloadPromocodeButton({ batchName }: { batchName: string }) {
  const toast = useToast();

  const mutation = useGetAgreementPromocodesFromBatchMutation({
    onSuccess(data) {
      downloadCSV(
        batchName,
        [
          {
            field: 'code',
            headerName: 'Código',
          },
          { field: 'used', headerName: 'Utilizado', valueFormatter: DataGridBooleanFormatter },
        ],
        data
      );
      toast({ title: 'Sucesso', description: 'Lote baixado com sucesso!', status: 'success' });
    },
    onError() {
      toast({
        title: 'Erro',
        description:
          'Não foi possível baixar este lote. Por favor entre em contato com o suporte em suporte@partiu.com.br',
        status: 'error',
      });
    },
  });
  return (
    <ChakraProvider>
      <Button size={'sm'} colorScheme="blue" onClick={() => mutation.mutate(batchName)} leftIcon={<FaDownload />}>
        Baixar CSV
      </Button>
    </ChakraProvider>
  );
}
